import * as React from "react";
import Layout from "./components/layout";

export const wrapPageElement = ({ element, props }): JSX.Element => (
  <Layout pageContext={props.pageContext}>{element}</Layout>
);
